import React from 'react'
import { t } from '@lingui/macro'
import { useLingui } from '@lingui/react'
import { Chip, Tooltip } from '@mui/material'
import dayjs from 'dayjs'

interface ImmediateConsultationBadgeProps {
  startDate?: string
  createdAt?: string
}

export const ImmediateConsultationBadge: React.FC<ImmediateConsultationBadgeProps> = ({ startDate, createdAt }) => {
  useLingui()

  if (!startDate || !createdAt) return null

  const start = dayjs(startDate)
  const created = dayjs(createdAt)

  const isImmediate = Math.abs(start.diff(created, 'minute')) <= 5

  if (!isImmediate) return null

  return (
    <Tooltip title={t`Patient requested immediate consultation`}>
      <Chip size="small" color="info" label={t`Immediate`} sx={{ ml: 1 }} />
    </Tooltip>
  )
}

export default ImmediateConsultationBadge
